module.exports = __webpack_public_path__ + "img/Billing-Details.cb5ed97c.jpg";